import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { SpaceOperationsFragment$key } from '@confluence/entity-operations/entry-points/SpaceOperationsFragmentKey.ts';

import type { BlogTreeInitialData_query$key } from '../src/__generated__/BlogTreeInitialData_query.graphql.ts';

export type { BlogTreeInitialData_query$key as BlogTreeInitialDataFragmentKey } from '../src/__generated__/BlogTreeInitialData_query.graphql.ts';

export const BlogTree: LoadableType<{
	initialDataFragmentRef?: BlogTreeInitialData_query$key;
	spaceKey: string;
	pageTreeFinishedLoading: boolean;
	spaceOperationsRef?: SpaceOperationsFragment$key;
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-BlogTree" */ '../src/BlogTree.tsx')).BlogTree,
});
